import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'

import SupervisorSuccessForm from '../../../../shared/components/supervisor/supervisor-success-form'

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '100vh',
    height: '100%',
  },

  icon: {
    fontSize: 90,
    mb: 2,
  },
}

const SupervisorApprovedSuccess = () => {
  return (
    <SupervisorSuccessForm
      icon={<AssignmentTurnedInIcon color='primary' sx={styles.icon} />}
      mode={'approved'}
    />
  )
}

export default SupervisorApprovedSuccess
